import styled from 'styled-components'

export const TextInput = styled.input`
    width: 100%;
`
